export default __webpack_public_path__ + "static/media/ncar_alt.804a8965.png";